import ContentArea from 'components/content-area/ContentArea';
import { ContentWithSidebar, Content, Sidebar } from 'components/content-with-sidebar';
import PageFooter from 'components/page-footer/PageFooter';
import ResponsiveIframe from 'components/responsive-iframe/ResponsiveIframe';
import RichText from 'components/rich-text/RichText';

import { IResponsiveIframePage } from 'source/NFR.types';

const ResponsiveIframePage: React.FC<IResponsiveIframePage> = ({ footer, iframe, richText, sidebar, title }) => (
  <div className="responsive-iframe-page">
    <ContentWithSidebar>
      <Content>{title && <h1>{title}</h1>}</Content>
      <Sidebar />
    </ContentWithSidebar>
    <ContentWithSidebar>
      <Content>
        <RichText {...richText} />
        <ResponsiveIframe {...iframe} />
        <div className="responsive-iframe-page--footer">
          <PageFooter {...footer} />
        </div>
      </Content>
      <Sidebar>
        <ContentArea enableElementSizing={false} {...sidebar} />
      </Sidebar>
    </ContentWithSidebar>
  </div>
);

ResponsiveIframePage.displayName = 'ResponsiveIframePage';

export default ResponsiveIframePage;
